import { render, staticRenderFns } from "./submit-task-description.vue?vue&type=template&id=1fa3488a&"
import script from "./submit-task-description.vue?vue&type=script&lang=js&"
export * from "./submit-task-description.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports